import script from "./CalendarView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarView.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarView.vue?vue&type=style&index=0&id=25a2594c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25a2594c"]])

export default __exports__